// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────
   EngineerLeave.css
   Self-contained styles for the leave management feature.
   Palette matches Engineer.css / EngineerAttendance.css (#185fa5 primary).
───────────────────────────────────────────── */

.lv-page {
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #1a1a1a;
}

/* ── TOP BAR ── */
.lv-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.25rem;
}
.lv-page-title {
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.3px;
  margin: 0 0 2px;
}
.lv-page-sub {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
}

/* ── ROLE TABS ── */
.lv-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.lv-tab {
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 10px 4px;
  margin-right: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.15s;
}
.lv-tab:hover { color: #185fa5; }
.lv-tab.active { color: #185fa5; border-bottom-color: #185fa5; }

/* ── BUTTONS ── */
.lv-btn-primary {
  background: #185fa5;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 9px 20px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}
.lv-btn-primary:hover { background: #0c447c; }
.lv-btn-primary:disabled { background: #93b8d8; cursor: not-allowed; }

.lv-btn-ghost {
  background: transparent;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 9px 20px;
  font-size: 13px;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s;
}
.lv-btn-ghost:hover { background: #f3f4f6; }
.lv-btn-ghost:disabled { opacity: 0.6; cursor: not-allowed; }
.lv-btn-sm { padding: 6px 14px; font-size: 12px; }

/* ── CARD ── */
.lv-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 1.5rem;
}
.lv-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e5e7eb;
}
.lv-card-title {
  font-size: 15px;
  font-weight: 600;
}

/* ── BALANCE PILLS ── */
.lv-balance-body {
  padding: 1.25rem;
}
.lv-month-chip {
  font-size: 11.5px;
  font-weight: 600;
  color: #185fa5;
  background: #eff6ff;
  border-radius: 20px;
  padding: 4px 12px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.lv-balance-message {
  background: #eff6ff;
  border: 1px solid #dbeafe;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px;
  color: #185fa5;
  margin-bottom: 1rem;
}
.lv-usage-bar-wrap {
  margin-bottom: 1.25rem;
}
.lv-usage-bar-track {
  width: 100%;
  height: 8px;
  border-radius: 20px;
  background: #f3f4f6;
  overflow: hidden;
  margin-bottom: 6px;
}
.lv-usage-bar-fill {
  height: 100%;
  border-radius: 20px;
  background: linear-gradient(90deg, #185fa5, #2f7fd1);
  transition: width 0.3s ease;
}
.lv-usage-bar-label {
  font-size: 12px;
  color: #6b7280;
}
.lv-balance-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 12px;
  margin-bottom: 1.25rem;
}
.lv-balance-pill {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px 16px;
  font-size: 12px;
  color: #6b7280;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.lv-balance-pill span {
  font-size: 22px;
  font-weight: 600;
  color: #111827;
}
.lv-pill-amber span { color: #b45309; }
.lv-pill-green span { color: #065f46; }
.lv-pill-red span { color: #e53935; }

/* ── SALARY STRIP ── */
.lv-salary-strip {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  border-top: 1px solid #e5e7eb;
  padding-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.lv-salary-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.lv-salary-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #9ca3af;
}
.lv-salary-value {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}
.lv-text-red { color: #e53935 !important; }
.lv-text-green { color: #065f46 !important; }

/* ── APPROVED LEAVES SECTION ── */
.lv-approved-section {
  border-top: 1px solid #e5e7eb;
  padding-top: 1.25rem;
}
.lv-approved-title {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 10px;
}
.lv-approved-section .lv-table th,
.lv-approved-section .lv-table td {
  padding: 10px 12px;
}

/* ── FORM ── */
.lv-form {
  padding: 1.25rem;
}
.lv-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;
}
.lv-form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 12px;
}
.lv-form-group label {
  font-size: 12px;
  font-weight: 500;
  color: #374151;
}
.lv-form-group input,
.lv-form-group select,
.lv-form-group textarea {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 8px 11px;
  font-size: 13px;
  background: #f9fafb;
  color: #111827;
  outline: none;
  width: 100%;
  transition: border-color 0.15s;
  font-family: inherit;
  resize: vertical;
}
.lv-form-group input:focus,
.lv-form-group select:focus,
.lv-form-group textarea:focus {
  border-color: #185fa5;
  background: #fff;
}

/* ── FILTERS (admin) ── */
.lv-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
}
.lv-filters input,
.lv-filters select {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 7px 10px;
  font-size: 13px;
  background: #fff;
  color: #111827;
  outline: none;
}
.lv-filters input[type="number"] { width: 130px; }
.lv-year-input { width: 90px; }

/* ── TABLE ── */
.lv-table {
  width: 100%;
  border-collapse: collapse;
}
.lv-table th {
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 10px 1.25rem;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
}
.lv-table td {
  padding: 13px 1.25rem;
  font-size: 13.5px;
  border-bottom: 1px solid #f3f4f6;
  color: #111827;
}
.lv-table tbody tr:last-child td { border-bottom: none; }
.lv-table tbody tr:hover td { background: #f9fafb; }
.lv-muted { color: #6b7280 !important; }

.lv-empty {
  text-align: center;
  padding: 3rem;
  font-size: 14px;
  color: #6b7280;
}

/* ── PAGINATION ── */
.lv-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 1rem 1.25rem;
}
.lv-page-info {
  font-size: 12.5px;
  color: #6b7280;
}

/* ── BADGES ── */
.lv-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 500;
}
.lv-badge-pending { background: #fef3c7; color: #b45309; }
.lv-badge-approved { background: #d1fae5; color: #065f46; }
.lv-badge-rejected { background: #fff3f3; color: #e53935; }
.lv-badge-cancelled { background: #f3f4f6; color: #6b7280; }
.lv-badge-default { background: #f3f4f6; color: #6b7280; }

/* ── MODAL ── */
.lv-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.lv-modal {
  background: #fff;
  border-radius: 14px;
  padding: 1.5rem;
  width: 100%;
  max-width: 440px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}
.lv-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}
.lv-modal-title {
  font-size: 17px;
  font-weight: 600;
  margin: 0;
}
.lv-close-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #e5e7eb;
  background: transparent;
  cursor: pointer;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  transition: background 0.15s;
}
.lv-close-btn:hover { background: #f3f4f6; }
.lv-modal-sub {
  font-size: 13px;
  color: #374151;
  margin-bottom: 8px;
  line-height: 1.5;
}
.lv-modal-reason {
  font-size: 13px;
  color: #6b7280;
  background: #f9fafb;
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 1rem;
}
.lv-modal-actions {
  display: flex;
  gap: 10px;
  margin-top: 0.5rem;
}

/* ── DECISION RADIO OPTIONS ── */
.lv-decision-options {
  display: flex;
  gap: 10px;
}
.lv-decision-option {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
  transition: all 0.15s;
}
.lv-decision-option input { accent-color: #185fa5; }
.lv-decision-approve.selected { border-color: #065f46; background: #d1fae5; color: #065f46; }
.lv-decision-reject.selected { border-color: #e53935; background: #fff3f3; color: #e53935; }

/* ── RESPONSIVE ── */
@media (max-width: 640px) {
  .lv-form-row { grid-template-columns: 1fr; }
  .lv-balance-grid { grid-template-columns: repeat(2, 1fr); }
  .lv-salary-strip { grid-template-columns: 1fr; }
  .lv-filters { flex-direction: column; }
  .lv-filters input, .lv-filters select { width: 100%; }
  .lv-table th:nth-child(4),
  .lv-table td:nth-child(4) { display: none; }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Engineer/Engineerleave/EngineerLeave.css"],"names":[],"mappings":"AAAA;;;;+CAI+C;;AAE/C;EACE,cAAc;EACd,sEAAsE;EACtE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;EACrB,gCAAgC;AAClC;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;AACA,gBAAgB,cAAc,EAAE;AAChC,iBAAiB,cAAc,EAAE,4BAA4B,EAAE;;AAE/D,kBAAkB;AAClB;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,wBAAwB,mBAAmB,EAAE;AAC7C,2BAA2B,mBAAmB,EAAE,mBAAmB,EAAE;;AAErE;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;AACA,sBAAsB,mBAAmB,EAAE;AAC3C,yBAAyB,YAAY,EAAE,mBAAmB,EAAE;AAC5D,aAAa,iBAAiB,EAAE,eAAe,EAAE;;AAEjD,eAAe;AACf;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,oDAAoD;EACpD,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA,sBAAsB,cAAc,EAAE;AACtC,sBAAsB,cAAc,EAAE;AACtC,oBAAoB,cAAc,EAAE;;AAEpC,uBAAuB;AACvB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA,eAAe,yBAAyB,EAAE;AAC1C,iBAAiB,yBAAyB,EAAE;;AAE5C,kCAAkC;AAClC;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;;;EAGE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;AAClB;AACA;;;EAGE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;AACA,mCAAmC,YAAY,EAAE;AACjD,iBAAiB,WAAW,EAAE;;AAE9B,gBAAgB;AAChB;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;AACA,mCAAmC,mBAAmB,EAAE;AACxD,8BAA8B,mBAAmB,EAAE;AACnD,YAAY,yBAAyB,EAAE;;AAEvC;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;;AAEzD,gBAAgB;AAChB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,4BAA4B;AAC9B;AACA,sBAAsB,mBAAmB,EAAE;AAC3C;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA,4BAA4B,qBAAqB,EAAE;AACnD,gCAAgC,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC5F,+BAA+B,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;;AAE3F,qBAAqB;AACrB;EACE,eAAe,0BAA0B,EAAE;EAC3C,mBAAmB,qCAAqC,EAAE;EAC1D,mBAAmB,0BAA0B,EAAE;EAC/C,cAAc,sBAAsB,EAAE;EACtC,wCAAwC,WAAW,EAAE;EACrD;8BAC4B,aAAa,EAAE;AAC7C","sourcesContent":["/* ─────────────────────────────────────────────\n   EngineerLeave.css\n   Self-contained styles for the leave management feature.\n   Palette matches Engineer.css / EngineerAttendance.css (#185fa5 primary).\n───────────────────────────────────────────── */\n\n.lv-page {\n  margin: 0 auto;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  color: #1a1a1a;\n}\n\n/* ── TOP BAR ── */\n.lv-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.25rem;\n}\n.lv-page-title {\n  font-size: 22px;\n  font-weight: 600;\n  letter-spacing: -0.3px;\n  margin: 0 0 2px;\n}\n.lv-page-sub {\n  font-size: 13px;\n  color: #6b7280;\n  margin: 0;\n}\n\n/* ── ROLE TABS ── */\n.lv-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 1.5rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n.lv-tab {\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  padding: 10px 4px;\n  margin-right: 20px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.lv-tab:hover { color: #185fa5; }\n.lv-tab.active { color: #185fa5; border-bottom-color: #185fa5; }\n\n/* ── BUTTONS ── */\n.lv-btn-primary {\n  background: #185fa5;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 9px 20px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.lv-btn-primary:hover { background: #0c447c; }\n.lv-btn-primary:disabled { background: #93b8d8; cursor: not-allowed; }\n\n.lv-btn-ghost {\n  background: transparent;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 9px 20px;\n  font-size: 13px;\n  color: #374151;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.lv-btn-ghost:hover { background: #f3f4f6; }\n.lv-btn-ghost:disabled { opacity: 0.6; cursor: not-allowed; }\n.lv-btn-sm { padding: 6px 14px; font-size: 12px; }\n\n/* ── CARD ── */\n.lv-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n  margin-bottom: 1.5rem;\n}\n.lv-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n.lv-card-title {\n  font-size: 15px;\n  font-weight: 600;\n}\n\n/* ── BALANCE PILLS ── */\n.lv-balance-body {\n  padding: 1.25rem;\n}\n.lv-month-chip {\n  font-size: 11.5px;\n  font-weight: 600;\n  color: #185fa5;\n  background: #eff6ff;\n  border-radius: 20px;\n  padding: 4px 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n.lv-balance-message {\n  background: #eff6ff;\n  border: 1px solid #dbeafe;\n  border-radius: 8px;\n  padding: 10px 14px;\n  font-size: 13px;\n  color: #185fa5;\n  margin-bottom: 1rem;\n}\n.lv-usage-bar-wrap {\n  margin-bottom: 1.25rem;\n}\n.lv-usage-bar-track {\n  width: 100%;\n  height: 8px;\n  border-radius: 20px;\n  background: #f3f4f6;\n  overflow: hidden;\n  margin-bottom: 6px;\n}\n.lv-usage-bar-fill {\n  height: 100%;\n  border-radius: 20px;\n  background: linear-gradient(90deg, #185fa5, #2f7fd1);\n  transition: width 0.3s ease;\n}\n.lv-usage-bar-label {\n  font-size: 12px;\n  color: #6b7280;\n}\n.lv-balance-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 12px;\n  margin-bottom: 1.25rem;\n}\n.lv-balance-pill {\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 12px 16px;\n  font-size: 12px;\n  color: #6b7280;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.lv-balance-pill span {\n  font-size: 22px;\n  font-weight: 600;\n  color: #111827;\n}\n.lv-pill-amber span { color: #b45309; }\n.lv-pill-green span { color: #065f46; }\n.lv-pill-red span { color: #e53935; }\n\n/* ── SALARY STRIP ── */\n.lv-salary-strip {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  border-top: 1px solid #e5e7eb;\n  padding-top: 1.25rem;\n  margin-bottom: 1.25rem;\n}\n.lv-salary-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.lv-salary-label {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #9ca3af;\n}\n.lv-salary-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #111827;\n}\n.lv-text-red { color: #e53935 !important; }\n.lv-text-green { color: #065f46 !important; }\n\n/* ── APPROVED LEAVES SECTION ── */\n.lv-approved-section {\n  border-top: 1px solid #e5e7eb;\n  padding-top: 1.25rem;\n}\n.lv-approved-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 10px;\n}\n.lv-approved-section .lv-table th,\n.lv-approved-section .lv-table td {\n  padding: 10px 12px;\n}\n\n/* ── FORM ── */\n.lv-form {\n  padding: 1.25rem;\n}\n.lv-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n.lv-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-bottom: 12px;\n}\n.lv-form-group label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #374151;\n}\n.lv-form-group input,\n.lv-form-group select,\n.lv-form-group textarea {\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 8px 11px;\n  font-size: 13px;\n  background: #f9fafb;\n  color: #111827;\n  outline: none;\n  width: 100%;\n  transition: border-color 0.15s;\n  font-family: inherit;\n  resize: vertical;\n}\n.lv-form-group input:focus,\n.lv-form-group select:focus,\n.lv-form-group textarea:focus {\n  border-color: #185fa5;\n  background: #fff;\n}\n\n/* ── FILTERS (admin) ── */\n.lv-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f9fafb;\n}\n.lv-filters input,\n.lv-filters select {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 7px 10px;\n  font-size: 13px;\n  background: #fff;\n  color: #111827;\n  outline: none;\n}\n.lv-filters input[type=\"number\"] { width: 130px; }\n.lv-year-input { width: 90px; }\n\n/* ── TABLE ── */\n.lv-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.lv-table th {\n  text-align: left;\n  font-size: 11px;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 10px 1.25rem;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f9fafb;\n}\n.lv-table td {\n  padding: 13px 1.25rem;\n  font-size: 13.5px;\n  border-bottom: 1px solid #f3f4f6;\n  color: #111827;\n}\n.lv-table tbody tr:last-child td { border-bottom: none; }\n.lv-table tbody tr:hover td { background: #f9fafb; }\n.lv-muted { color: #6b7280 !important; }\n\n.lv-empty {\n  text-align: center;\n  padding: 3rem;\n  font-size: 14px;\n  color: #6b7280;\n}\n\n/* ── PAGINATION ── */\n.lv-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  padding: 1rem 1.25rem;\n}\n.lv-page-info {\n  font-size: 12.5px;\n  color: #6b7280;\n}\n\n/* ── BADGES ── */\n.lv-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 500;\n}\n.lv-badge-pending { background: #fef3c7; color: #b45309; }\n.lv-badge-approved { background: #d1fae5; color: #065f46; }\n.lv-badge-rejected { background: #fff3f3; color: #e53935; }\n.lv-badge-cancelled { background: #f3f4f6; color: #6b7280; }\n.lv-badge-default { background: #f3f4f6; color: #6b7280; }\n\n/* ── MODAL ── */\n.lv-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n.lv-modal {\n  background: #fff;\n  border-radius: 14px;\n  padding: 1.5rem;\n  width: 100%;\n  max-width: 440px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n}\n.lv-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.75rem;\n}\n.lv-modal-title {\n  font-size: 17px;\n  font-weight: 600;\n  margin: 0;\n}\n.lv-close-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 1px solid #e5e7eb;\n  background: transparent;\n  cursor: pointer;\n  font-size: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b7280;\n  transition: background 0.15s;\n}\n.lv-close-btn:hover { background: #f3f4f6; }\n.lv-modal-sub {\n  font-size: 13px;\n  color: #374151;\n  margin-bottom: 8px;\n  line-height: 1.5;\n}\n.lv-modal-reason {\n  font-size: 13px;\n  color: #6b7280;\n  background: #f9fafb;\n  border-radius: 8px;\n  padding: 10px 12px;\n  margin-bottom: 1rem;\n}\n.lv-modal-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 0.5rem;\n}\n\n/* ── DECISION RADIO OPTIONS ── */\n.lv-decision-options {\n  display: flex;\n  gap: 10px;\n}\n.lv-decision-option {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 12px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  color: #6b7280;\n  transition: all 0.15s;\n}\n.lv-decision-option input { accent-color: #185fa5; }\n.lv-decision-approve.selected { border-color: #065f46; background: #d1fae5; color: #065f46; }\n.lv-decision-reject.selected { border-color: #e53935; background: #fff3f3; color: #e53935; }\n\n/* ── RESPONSIVE ── */\n@media (max-width: 640px) {\n  .lv-form-row { grid-template-columns: 1fr; }\n  .lv-balance-grid { grid-template-columns: repeat(2, 1fr); }\n  .lv-salary-strip { grid-template-columns: 1fr; }\n  .lv-filters { flex-direction: column; }\n  .lv-filters input, .lv-filters select { width: 100%; }\n  .lv-table th:nth-child(4),\n  .lv-table td:nth-child(4) { display: none; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
